export default {
	apiKey: 'AIzaSyAMsW_gbDrtQ1BfxC78P58ixApyMxLI-_k',
	discoveryDocs: ["https://sheets.googleapis.com/$discovery/rest?version=v4"],
	spreadsheetId: '1rKbwKRIwxEOjcY5xTDJFZf4Ir_9MQzDmARr6hWljvEg'
}
